import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { catMap } from "@/lib/categories";
import { useAuth } from "@/context/AuthContext";
import { UshqimForm } from "@/components/UshqimForm";
import { BanimForm } from "@/components/BanimForm";
import { UdhetimForm } from "@/components/UdhetimForm";
import { DyqanForm } from "@/components/DyqanForm";
import { PuneForm } from "@/components/PuneForm";
import { PunekerkuesForm } from "@/components/PunekerkuesForm";
import { SherbimForm } from "@/components/SherbimForm";
import { GenericForm } from "@/components/GenericForm";
import { ReklameForm } from "@/components/ReklameForm";
import { FormCfgProvider } from "@/lib/formcfg";
import { toast } from "sonner";

export default function EditListingPage() {
  const { id } = useParams();
  const nav = useNavigate();
  const { user, setAuthOpen } = useAuth();
  const [listing, setListing] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => { if (user === false) setAuthOpen(true); }, [user, setAuthOpen]);
  useEffect(() => { api.get(`/listings/${id}/draft`).catch(() => api.get(`/listings/${id}`)).then((r) => setListing(r.data)).catch(() => { setErr(true); toast.error("Shpallja nuk u gjet"); }); }, [id]);

  if (!user || user === false) return <div className="p-8 text-center text-slate-500">Kyçu për të ndryshuar shpalljen.</div>;
  if (err) return <div className="p-8 text-center text-slate-400">Shpallja nuk u gjet.</div>;
  if (!listing) return <div className="p-8 text-center text-slate-400">Duke ngarkuar...</div>;

  const done = () => nav(`/shpallje/${listing.id}`);
  const k = listing.category;
  return <FormCfgProvider cat={k} initial={listing}>{pick(k)}</FormCfgProvider>;
  function pick() {
  if (k === "ushqim") return <UshqimForm category={catMap.ushqim} initial={listing} onDone={done} />;
  if (k === "banim") return <BanimForm initial={listing} onDone={done} />;
  if (k === "udhetim") return <UdhetimForm initial={listing} onDone={done} />;
  if (k === "dyqan") return <DyqanForm initial={listing} onDone={done} />;
  if (k === "pune") return <PuneForm initial={listing} onDone={done} />;
  if (k === "punekerkues") return <PunekerkuesForm initial={listing} onDone={() => nav(`/punekerkues/${listing.id}`)} />;
  if (k === "sherbime") return <SherbimForm initial={listing} onDone={done} />;
  if (k === "reklame") return <ReklameForm initial={listing} onDone={done} />;
  return <GenericForm category={catMap[k] || catMap.sherbime} initial={listing} onDone={done} />;
  }
}
